/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from 'react';
import { SyncMachineService, syncMachineService } from '@/services/sync-state';

/**
 * Provides access to the SyncMachineService singleton throughout the app.
 *
 * The default value is the module-level singleton so no provider is
 * strictly required for production use — but wrapping in a provider
 * enables replacing the service in tests.
 */
const SyncMachineContext = createContext<SyncMachineService>(syncMachineService);

interface SyncMachineProviderProps {
  children: React.ReactNode;
  /** Override the service instance — useful in tests. */
  service?: SyncMachineService;
}

export const SyncMachineProvider: React.FC<SyncMachineProviderProps> = ({
  children,
  service = syncMachineService,
}) => (
  <SyncMachineContext.Provider value={service}>
    {children}
  </SyncMachineContext.Provider>
);

/**
 * Returns the nearest SyncMachineService instance from context.
 * Falls back to the module-level singleton if no provider is present.
 */
export const useSyncMachineService = (): SyncMachineService =>
  useContext(SyncMachineContext);
